import type { LocationQuery } from 'vue-router'
import type { TokenPackage } from '@/models'
import { serviceErrorHandbook } from '@/models'
import { HttpErrorService } from '@/services/HttpError.service'
import { HttpService } from '@/services/Http.service'

export class SocialCallbackService {
  private endpoint = '/users/social-callback'
  private httpErrorService: HttpErrorService<keyof typeof serviceErrorHandbook>
  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      serviceErrorHandbook,
      'social-callback',
    )
  }

  async getToken(query: LocationQuery) {
    return await this.httpService
      .get<TokenPackage>(this.endpoint, {
        fetchConfig: {
          query,
        },
        requestConfig: {
          secure: true,
          forceRequest: true,
          cancellable: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, this.endpoint)
      })
  }
}
